import { CONTAIN_SPECIAL_CHARACTER_REGEXP } from './regex';

export const containsOnlyEnglishCharacters = (value: string) =>
  !CONTAIN_SPECIAL_CHARACTER_REGEXP.test(value);
